import SustainabilityWidget from './SustainabilityWidget';

export default SustainabilityWidget;
